/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CloudProviderEnum } from './cloudProviderEnum';
import { Components } from './components';
import { ReleaseStateEnum } from './releaseStateEnum';
import { ServiceTypeEnum } from './serviceTypeEnum';
import { VcdsPersonaEnum } from './vcdsPersonaEnum';
import { ReleaseTypeEnum } from './releaseTypeEnum';


export interface UpdateReleaseSpec { 
    /**
     * Version String for a release
     */
    version: string;
    service_type: ServiceTypeEnum;
    release_type: ReleaseTypeEnum;
    cloud_provider?: CloudProviderEnum;
    persona?: VcdsPersonaEnum;
    state?: ReleaseStateEnum;
    /**
     * Add release to the upgradeFrom list
     */
    add_to_upgrade_from?: string;
    /**
     * Remove release from the upgradeFrom list
     */
    remove_from_upgrade_from?: string;
    /**
     * If true (default false), skip some validation to load this release in SaaSInfra.
     */
    skip_validation?: boolean;
    /**
     * Check and update the deployment\'s upgrade status
     */
    update_upgrade_status?: boolean;
    components?: Components;
    /**
     * Comments/Notes regarding this release
     */
    notes?: string;
}
export namespace UpdateReleaseSpec {
}


